import { ValidatorFn, Validators } from "@angular/forms";
import { UniqueNameValidator } from "./uniqueName.validator";

// Standard validators for a "name" column in the settings grids, mirroring the backend rules
// (NotEmpty, MaximumLength, unique name). Whitespace-only names fail the pattern check.
export function NameValidators(existingNames: () => string[], maxLength: number, caseSensitive = false): ValidatorFn[] {
  return [
    Validators.required,
    Validators.pattern(/\S/),
    Validators.maxLength(maxLength),
    UniqueNameValidator(existingNames, caseSensitive),
  ];
}
